// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar__chCci {
  font-family: "Roboto", sans-serif;
  max-width: 210px;
  width: 100%;
  max-height: 100%;
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  align-items: flex-start;
  justify-content: space-between;
  background: #2c2d31;
  position: sticky;
  top: 0;
  height: 100dvh;
  z-index: 3;
  transition: width 500ms ease-in-out;
  border-right: 1px solid var(--side-menu-stroke);
}
@media (max-width: 850px) {
  .sidebar__chCci {
    max-width: 180px;
    font-size: 11px;
  }
}
@media (max-width: 640px) {
  .sidebar__chCci {
    position: absolute;
    z-index: 10;
    transform: translateX(0px);
    transition: all 150ms ease-in;
  }
}

.hiddenSidebar__jHrXm {
  width: 90px;
  overflow: visible;
  z-index: 3;
}
@media (max-width: 850px) {
  .hiddenSidebar__jHrXm {
    width: 62px;
  }
}
@media (max-width: 640px) {
  .hiddenSidebar__jHrXm {
    transform: translateX(-210px);
    transition: all 150ms ease-in;
  }
}

.sidebarNav__XrXVP {
  width: 100%;
  height: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #2c2d31;
  overflow-y: scroll;
}
.sidebarNav__XrXVP::-webkit-scrollbar {
  display: none;
}

.sidebarNavTopContainer__vZd9M,
.sidebarNavBottomContainer__dpK_Z {
  padding: 0 25px;
}
@media (max-width: 850px) {
  .sidebarNavTopContainer__vZd9M,
  .sidebarNavBottomContainer__dpK_Z {
    padding: 0 20px;
  }
}

.sidebarNavBottomContainer__dpK_Z {
  margin-top: 15px;
}

.closedSidebarNavBottomContainer__uw5eD {
  padding: unset;
}
.closedSidebarNavBottomContainer__uw5eD .hasNewMessage__Vo6Mg::after {
  top: 0px;
  right: 25px;
}

.facilityAdministrationBlock__dXICY {
  padding: 0 25px;
}
@media (max-width: 850px) {
  .facilityAdministrationBlock__dXICY {
    padding: 0 20px;
  }
}

.collapseWrap__aHDsZ {
  padding: 15px 25px;
  background-color: #1f1f1f;
}
@media (max-width: 850px) {
  .collapseWrap__aHDsZ {
    padding: 10px 20px;
  }
}

.hasNewMessage__Vo6Mg {
  position: relative;
}
.hasNewMessage__Vo6Mg::after {
  content: "";
  width: 5px;
  height: 5px;
  background-color: #fdc526;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  right: 38px;
}
@media (max-width: 850px) {
  .hasNewMessage__Vo6Mg::after {
    right: 32px;
    top: 4px;
  }
}

.showMenuIcon__TnjsU {
  transform: scale(-1, 1);
}

@media (max-width: 640px) {
  .hideMenuNavItem__WM9dF {
    position: absolute;
    top: 20%;
    right: -20px;
    z-index: 10;
    background: #2c2d31;
    border-radius: 0 5px 5px 0;
  }
  .hideMenuNavItem__WM9dF div:last-child {
    display: none;
  }
}

@media (max-width: 640px) {
  .closedHideMenuNavItem__UAamR {
    right: -155px;
    transition: all 150ms ease-in;
  }
}

.userImage__JmjdP {
  background: #747A8E;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 1;
}
.userImage__JmjdP img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 850px) {
  .userImage__JmjdP {
    width: 24px;
    height: 24px;
  }
}

.userProfileBlock__qIoDR {
  padding: 15px 25px;
}
@media (max-width: 850px) {
  .userProfileBlock__qIoDR {
    padding: 10px 20px;
  }
}

.userProfileNavItem__IeqeV {
  margin: unset;
}

.mapIconSvg__NoaoG path {
  fill: #fff;
}

.manageFacilityIcon__l4hAY {
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/Sidebar/style.module.scss","webpack://./../src/assets/variables.scss"],"names":[],"mappings":"AA4EA;EACE,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,cAAA;EACA,UAAA;EACA,mCAAA;EACA,+CAAA;AA3EF;AA6EE;EAnBF;IAoBI,gBAAA;IACA,eAAA;EA1EF;AACF;AA4EE;EAxBF;IAyBI,kBAAA;IACA,WAAA;IACA,0BAAA;IACA,6BAAA;EAzEF;AACF;;AA4EA;EACE,WAAA;EACA,iBAAA;EACA,UAAA;AAzEF;AA2EE;EALF;IAMI,WAAA;EAxEF;AACF;AA0EE;EATF;IAUI,6BAAA;IACA,6BAAA;EAvEF;AACF;;AA0EA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAvEF;AAyEE;EACE,aAAA;AAvEJ;;AA2EA;;EAEE,eAAA;AAxEF;AA0EE;EAJF;;IAKI,eAAA;EAtEF;AACF;;AAyEA;EACE,gBAAA;AAtEF;;AAyEA;EACE,cAAA;AAtEF;AAyEI;EACE,QAAA;EACA,WAAA;AAvEN;;AA4EA;EACE,eAAA;AAzEF;AA2EE;EAHF;IAII,eAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;EACA,yBAAA;AAxEF;AA0EE;EAJF;IAKI,kBAAA;EAvEF;AACF;;AA0EA;EACE,kBAAA;AAvEF;AAyEE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAvEJ;AA0EE;EACE;IACE,WAAA;IACA,QAAA;EAxEJ;AACF;;AA4EA;EACE,uBAAA;AAzEF;;AA6EE;EADF;IAEI,kBAAA;IACA,QAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,0BAAA;EAzEF;EA0EE;IACE,aAAA;EAxEJ;AACF;;AA6EE;EADF;IAEI,aAAA;IACA,6BAAA;EAzEF;AACF;;AA4EA;EACE,mBC/MO;EDgNP,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAzEF;AA2EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAzEJ;AA4EE;EAfF;IAgBI,WAAA;IACA,YAAA;EAzEF;AACF;;AA4EA;EACE,kBAAA;AAzEF;AA2EE;EAHF;IAII,kBAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;AAxEF;;AA4EE;EACE,UAAA;AAzEJ;;AA6EA;EACE,cAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.sidebar {\n  font-family: 'Roboto', sans-serif;\n  max-width: 210px;\n  width: 100%;\n  max-height: 100%;\n  padding-top: 25px;\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n  align-items: flex-start;\n  justify-content: space-between;\n  background: #2c2d31;\n  position: sticky;\n  top: 0;\n  height: 100dvh;\n  z-index: 3;\n  transition: width 500ms ease-in-out;\n  border-right: 1px solid var(--side-menu-stroke);\n\n  @media (max-width: 850px) {\n    max-width: 180px;\n    font-size: 11px;\n  }\n\n  @media (max-width: 640px) {\n    position: absolute;\n    z-index: 10;\n    transform: translateX(0px);\n    transition: all 150ms ease-in;\n  }\n}\n\n.hiddenSidebar {\n  width: 90px;\n  overflow: visible;\n  z-index: 3;\n\n  @media (max-width: 850px) {\n    width: 62px;\n  }\n\n  @media (max-width: 640px) {\n    transform: translateX(-210px);\n    transition: all 150ms ease-in;\n  }\n}\n\n.sidebarNav {\n  width: 100%;\n  height: 100%;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: #2c2d31;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.sidebarNavTopContainer,\n.sidebarNavBottomContainer {\n  padding: 0 25px;\n\n  @media (max-width: 850px) {\n    padding: 0 20px;\n  }\n}\n\n.sidebarNavBottomContainer {\n  margin-top: 15px;\n}\n\n.closedSidebarNavBottomContainer {\n  padding: unset;\n\n  .hasNewMessage {\n    &::after {\n      top: 0px;\n      right: 25px;\n    }\n  }\n}\n\n.facilityAdministrationBlock {\n  padding: 0 25px;\n\n  @media (max-width: 850px) {\n    padding: 0 20px;\n  }\n}\n\n.collapseWrap {\n  padding: 15px 25px;\n  background-color: #1f1f1f;\n\n  @media (max-width: 850px) {\n    padding: 10px 20px;\n  }\n}\n\n.hasNewMessage {\n  position: relative;\n\n  &::after {\n    content: '';\n    width: 5px;\n    height: 5px;\n    background-color: #fdc526;\n    border-radius: 50%;\n    position: absolute;\n    top: 5px;\n    right: 38px;\n  }\n\n  @media (max-width: 850px) {\n    &::after {\n      right: 32px;\n      top: 4px;\n    }\n  }\n}\n\n.showMenuIcon {\n  transform: scale(-1, 1);\n}\n\n.hideMenuNavItem {\n  @media (max-width: 640px) {\n    position: absolute;\n    top: 20%;\n    right: -20px;\n    z-index: 10;\n    background: #2c2d31;\n    border-radius: 0 5px 5px 0;\n    div:last-child {\n      display: none;\n    }\n  }\n}\n\n.closedHideMenuNavItem {\n  @media (max-width: 640px) {\n    right: -155px;\n    transition: all 150ms ease-in;\n  }\n}\n\n.userImage {\n  background: $gray-2;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n  z-index: 1;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n\n  @media (max-width: 850px) {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.userProfileBlock {\n  padding: 15px 25px;\n\n  @media (max-width: 850px) {\n    padding: 10px 20px;\n  }\n}\n\n.userProfileNavItem {\n  margin: unset;\n}\n\n.mapIconSvg {\n  path {\n    fill: #fff;\n  }\n}\n\n.manageFacilityIcon {\n  padding: 0 4px;\n}\n","$black: #000000;\n$white: #FFFFFF;\n$white-1: #F2F4F9;\n$white-2: #D0D6E5;\n$turquoise: #3697AB;\n$blue-1: #82C6D4;\n$blue-2: #D5EBEF;\n$red-1: #B92C2C;\n$red-2: #FFCFCF;\n$green-1: #12ac6c;\n$green-2: #66C890;\n$green-3: #DDEFD5;\n$green-4: #3DE0A1;\n$orange-1: #F48E62;\n$orange-2: #FEB805;\n$yellow-1: #F4DA62;\n$yellow-2: #FFECAA;\n$dark-blue-1: #13161F;\n$dark-blue-2: #232732;\n$gray-1: #494D5B;\n$gray-2: #747A8E;\n$gray-3: #A6A6A6;\n$gray-4: #6F7B87;\n\n$yellow-0: #F4D115;\n$yellow: #F8C71C;\n$red-0: #F82D46;\n$red: #F24F52;\n$green-0: #42AD7E;\n$orange-0: #F9845A;\n$gray-0: #75899D;\n$blue-0: #3C97AA;\n$blue: #17B5D6;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sidebar__chCci`,
	"hiddenSidebar": `hiddenSidebar__jHrXm`,
	"sidebarNav": `sidebarNav__XrXVP`,
	"sidebarNavTopContainer": `sidebarNavTopContainer__vZd9M`,
	"sidebarNavBottomContainer": `sidebarNavBottomContainer__dpK_Z`,
	"closedSidebarNavBottomContainer": `closedSidebarNavBottomContainer__uw5eD`,
	"hasNewMessage": `hasNewMessage__Vo6Mg`,
	"facilityAdministrationBlock": `facilityAdministrationBlock__dXICY`,
	"collapseWrap": `collapseWrap__aHDsZ`,
	"showMenuIcon": `showMenuIcon__TnjsU`,
	"hideMenuNavItem": `hideMenuNavItem__WM9dF`,
	"closedHideMenuNavItem": `closedHideMenuNavItem__UAamR`,
	"userImage": `userImage__JmjdP`,
	"userProfileBlock": `userProfileBlock__qIoDR`,
	"userProfileNavItem": `userProfileNavItem__IeqeV`,
	"mapIconSvg": `mapIconSvg__NoaoG`,
	"manageFacilityIcon": `manageFacilityIcon__l4hAY`
};
module.exports = ___CSS_LOADER_EXPORT___;
